@if (push?.media) {
  <sd-banner
    [isComponentLoading]="isLoading"
    [isFit]="isFit"
    [isAriaHidden]="true"
    [imgRatio]="isMobile$ ? imageRatioEnum.r5_3 : imageRatioEnum.r5_4"
    [hasModal]="!mediaAsBackground && hasModal"
    [media]="push.media"
    [videoTitle]="push?.richParagraph?.heading?.data?.title"
    [hasAltText]="false"
    [twicPicsAutoSize]="twicPicsAutoSize"
  />
}
@if (push) {
  <sd-rich-paragraph
    [miniPush]="true"
    [brand]="brand"
    [isLoading]="isLoading"
    [isDescription]="isDescription"
    [contentData]="push?.richParagraph"
    (clicked)="onClick($event)"
    [titleLevel]="titleLevel"
    [textConfig]="textConfig.left"
  />
}
